// 新聞文章＋加密學院文章 標題摘要 ＋作者
import dayjs from 'dayjs';
import Image from 'next/image';
import Link from 'next/link';
import NewsBrief from './NewsBrief'; // 新聞摘要（AI + 原始）

const NewsTitle = ({ news, t, type, level = 1, locale }) => {
    const time = dayjs(news?.modifiedTime).format('YYYY.MM.DD');

    return (
        <div className="space-y-[22px] w-full">
            {/* 標題 */}
            <h1 className="text-h1 text-black usm:text-h2 uxs:!text-h3">{news?.title}</h1>
            <div className="between-center usx:flex-col usx:items-start usx:gap-y-[14px]">
                <div className="flex items-center gap-x-[10px]">
                    {/* 學院 */}
                    {type === 'academy' ? (
                        <span className="text-btn1 text-white px-[20px] rounded-[40px] py-[5px] bg-pale9">
                            加密{t(`LEVEL_${level}`)}
                        </span>
                    ) : // 新聞
                    news?.reporterId ? (
                        <Link
                            href={`/author/${news?.author}`}
                            className="flex items-center gap-x-[10px]"
                        >
                            {/* 頭像 */}
                            <Image
                                src={news?.userImage || '/images/layout/default_head.png'}
                                width={30}
                                height={30}
                                alt={news?.reporter + 'thumbnail'}
                                className="rounded-[50%] overflow-hidden object-cover"
                            />
                            {/* 職稱 */}
                            <span className="text-btn1 px-[10px] py-[3px] border-1 border-black2  text-black8 rounded-[2px]">
                                {news?.reporterTitle}
                            </span>
                            {/* 作者名稱 */}
                            <span className="text-btn1b text-black9">{news?.reporter}</span>
                        </Link>
                    ) : (
                        <>
                            {/* 頭像 */}
                            <Image
                                src={news?.userImage || '/images/layout/default_head.png'}
                                width={30}
                                height={30}
                                alt={news?.reporter + 'thumbnail'}
                                className="rounded-[50%] overflow-hidden object-cover"
                            />
                            {/* 職稱 */}
                            <span className="text-btn1 px-[10px] py-[3px] border-1 border-black2  text-black8 rounded-[2px]">
                                {news?.reporterTitle}
                            </span>
                            {/* 作者名稱 */}
                            <span className="text-btn1b text-black9">{news?.reporter}</span>
                        </>
                    )}
                </div>

                <p className="text-bd4n text-black9">
                    {type === 'academy' ? (
                        <>
                            {t('UPDATE')}：{}
                        </>
                    ) : (
                        <Link
                            href={
                                locale === 'tw'
                                    ? `/news?category=${news?.category}`
                                    : `/cn/news?category=${news?.category}`
                            }
                            className="trans hover:text-pale"
                        >
                            {t(news?.category?.toUpperCase())}&nbsp;&nbsp;
                        </Link>
                    )}
                    {time}
                </p>
            </div>

            {/* 摘要 */}
            <NewsBrief brief={news?.brief} briefAi={news?.briefAi} slug={news?.slug} />

            {/* 新聞圖片 */}
            <div className="img-box w-full aspect-[690/357] rounded-[2px] overflow-hidden after:content-none">
                <Image
                    width={690}
                    height={357}
                    src={
                        news?.image ||
                        news?.imageHome ||
                        news?.imageFb ||
                        '/images/news/default_related.svg'
                    }
                    alt={news?.imageAlt || news?.brief + news?.title || 'news_title'}
                    loading="eager"
                    sizes="(max-width: 413px) 380px, (max-width: 599px) 400px, 640px"
                />
            </div>
        </div>
    );
};

export default NewsTitle;
